import type { MessageHistoryStatus } from './messagingHistory.types';

interface StatusConfig {
  label: string;
  background: string;
  color: string;
}

export const CONTENT_MEDIA_QUERY = '@media (min-width: 1200px)';

export const ERROR_STATUSES = new Set([
  'failed',
  'completedWithErrors',
  'partially_cancelled',
  'cancellation_failed',
]);

export const LOADING_STATUSES = new Set([
  'processing',
  'sending',
  'validating',
  'cancelling',
  'processed',
]);

export const MESSAGE_HISTORY_STATUS_CONFIG: Record<
  MessageHistoryStatus,
  StatusConfig
> = {
  successful: {
    label: 'Successful',
    background: 'messageStatusSuccessfulBackground',
    color: 'messageStatusSuccessfulText',
  },
  processing: {
    label: 'Processing',
    background: 'messageStatusProcessingBackground',
    color: 'messageStatusProcessingText',
  },
  scheduled: {
    label: 'Scheduled',
    background: 'messageStatusScheduledBackground',
    color: 'messageStatusScheduledText',
  },
  preparing: {
    label: 'Preparing',
    background: 'messageStatusPreparingBackground',
    color: 'messageStatusPreparingText',
  },
  failed: {
    label: 'Failed',
    background: 'messageStatusFailedBackground',
    color: 'messageStatusFailedText',
  },
  cancelled: {
    label: 'Cancelled',
    background: 'messageStatusCancelledBackground',
    color: 'messageStatusCancelledText',
  },
  completedWithErrors: {
    label: 'Completed with errors',
    background: 'messageStatusWarningBackground',
    color: 'messageStatusWarningText',
  },
  partiallyCancelled: {
    label: 'Partially cancelled',
    background: 'messageStatusCancelledBackground',
    color: 'messageStatusCancelledText',
  },
  cancellationFailed: {
    label: 'Cancellation failed',
    background: 'messageStatusWarningBackground',
    color: 'messageStatusWarningText',
  },
};
